"use client";

/**
 * NewForm DS hover icon — an upward arrow for "send message".
 * On hover the arrow launches off the top and re-enters from the bottom,
 * so the glyph reads as dispatched rather than merely nudged.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function SendIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-launch">
        <path d="M12 19.4V5.1" />
        <path d="m5.6 11.5 6.4-6.4 6.4 6.4" />
      </g>
    </HoverIconSvg>
  );
}
